export default "__VITE_ASSET__Ck5B7nll__"